/*-----------------------------------------------------------------------------------
 * Kingsoft Office Enterprise Cloud Services.
 * Copyright (c) Kingsoft Office,All rights reserved.
 *-----------------------------------------------------------------------------------*/
import { getQuery } from '@util'
import { getOemSupported, isWPSClient } from '@util/wpsoffice'
import { isEduEnvSync } from '@util/edu'
import { decryptTextWithToken } from '@util/encrypt'

export const isWpsPlusVersion = userAgent => {
  const ua = userAgent || navigator.userAgent
  return ua.toLowerCase().indexOf('wpsplusversion') >= 0
}

// 手机号前置，可游客流程
export const isTouristFlow = () => {
  const { token, creator_auth_type } = getQuery() || {}
  // 商业版引导状态入参或携带token游客创建，如果是，则支持不检查登录状态流程，支持游客状态流程，目前只放开创建企业入口及其引导入两个路由：sign-up、tourist-guide
  return (
    creator_auth_type === 'login_method' &&
    token &&
    [
      '/sign-up',
      '/tourist-guide',
      '/3rd/plus/sign-up',
      '/3rd/plus/tourist-guide',
    ].includes(location.pathname)
  )
}

/**
 * 判断是否为专业版
 * */
let isBusinessStatusGuide = null
export const getBusinessGuideStatus = () => {
  // 商业版引导状态入参或携带token游客创建，如果是，则支持不检查登录状态流程，支持游客状态流程，目前只放开创建企业入口及其引导入两个路由：sign-up、tourist-guide
  if (isTouristFlow()) {
    return true
  }

  if (!isWPSClient()) {
    return false
  }

  if (isBusinessStatusGuide !== null) {
    return isBusinessStatusGuide
  }

  isBusinessStatusGuide = isWpsPlusVersion()

  return isBusinessStatusGuide
}

let businessSsid = null
export const getBusinessSsid = () => {
  if (businessSsid) return businessSsid
  const { ssid } = getQuery() || {}
  businessSsid = ssid

  return businessSsid
}

let tokenAndPhoneInfo = null
export const getQueryTokenAndPhone = () => {
  if (tokenAndPhoneInfo) return tokenAndPhoneInfo
  const { token, phone } = getQuery() || {}

  if (!token || !phone) return {}

  const decodeToken = decodeURIComponent(token)
  const decodePhone = decodeURIComponent(phone)
  const decryptPhone = decryptTextWithToken(decodeToken, decodePhone) // 解密后的phone
  tokenAndPhoneInfo = { token: decodeToken, phone: decryptPhone }

  return tokenAndPhoneInfo
}
